/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CrossIcon16 from "assets/svgs/CrossIcon16";
import clsx from "clsx";
import useIsDesktop from "hooks/useIsDesktop";
import React from "react";
import {
	getGlobalCSSVariantSelectBorderBg,
	getGlobalCSSVariantTextFieldBorder,
} from "theme";
import { isHostLaunchedMicrosite } from "utils";
import { MICROSITES } from "utils/constants";

type SelectChipOptions = {
	label: string;
	onDelete: () => void;
};
type SelectChipsContainerProps = {
	options: SelectChipOptions[];
};

const SelectChipsContainer: React.FC<SelectChipsContainerProps> = ({ options }) => {
	const isDesktopView = useIsDesktop();
	return (
		<div
			className={clsx("back scrollbarHide flex overflow-x-auto px-[16px] py-[8px]")}
			style={{
				background:
					isHostLaunchedMicrosite() === MICROSITES.VI
						? getGlobalCSSVariantSelectBorderBg().primarySelectionBg
						: "#EAF8F4",
			}}
		>
			{options.map((option) => (
				<div
					key={option.label}
					className={clsx(
						"mr-[8px] flex shrink-0 cursor-pointer items-center rounded-[24px] border bg-[#fff] px-[12px] py-[8px]",
						{
							"text-[16px] leading-[24px]": isDesktopView,
							"text-[14px] leading-[20px]": !isDesktopView,
						}
					)}
					style={{
						borderColor:
							isHostLaunchedMicrosite() === MICROSITES.VI
								? getGlobalCSSVariantTextFieldBorder().primaryColor
								: "#BDE9DD",
					}}
					onClick={option.onDelete}
				>
					{option.label}
					<CrossIcon16 className="ml-[4px]" />
				</div>
			))}
		</div>
	);
};

export default SelectChipsContainer;
